import { type BillingProfile } from 'gpcore-grpc/gpcore/api/cloud/v1/billing_pb';
import { type InjectionKey, type Ref } from 'vue';

export const BillingProfileInject = Symbol('BillingProfileKey') as InjectionKey<
  Ref<BillingProfile>
>;

export default { BillingProfileInject };
